import { hasProperty } from '../../../helpers';
import { ThemeName } from '../../../types';
import * as fontFaceStyles from '../font-face-styles';

export const getFontFaceStyles = (themeName: ThemeName) =>
  hasProperty(fontFaceStyles, themeName)
    ? fontFaceStyles[themeName as keyof typeof fontFaceStyles]
    : '';
